export const baseUrl = "http://api.rrsd.hostober.pk";
const servers = {
  localhost: "http://localhost:3000",
  "rrsd.hostober.pk": "http://rrsd.hostober.pk",
};

export const baseClientUrl = servers[window.location.hostname];
